"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ConfigTab = _interopRequireDefault(require("./components/ConfigTab.vue"));
var _UserFilterTab = _interopRequireDefault(require("./components/UserFilterTab.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderViewConfig',
  components: {
    ConfigTab: _ConfigTab.default,
    UserFilterTab: _UserFilterTab.default
  },
  data: function data() {
    return {
      activeName: 'config',
      refreshLoading: false
    };
  },
  methods: {
    refreshCurrentTab: function refreshCurrentTab() {
      var _this = this;
      this.refreshLoading = true;
      var currentTab = this.activeName;
      try {
        if (currentTab === 'config' && this.$refs.configTab) {
          this.$refs.configTab.fetchConfigList();
        } else if (currentTab === 'userFilter' && this.$refs.userFilterTab) {
          this.$refs.userFilterTab.refreshData();
        }
      } catch (error) {
        console.error('刷新数据失败:', error);
      } finally {
        setTimeout(function () {
          _this.refreshLoading = false;
        }, 500);
      }
    },
    handleTabClick: function handleTabClick() {
      this.refreshCurrentTab();
    }
  }
};